import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendResponse } from 'src/app/core/interfaces/shared.interface';
import { SharedService } from 'src/app/core/services/shared.service';
import { SelfPublishTag } from '../companies/companies.interface';
import { CreatedFileType, FileType, PatchFileType } from './tags.interface';

@Injectable({ providedIn: 'root' })
export class TagsService {
  constructor(private http: HttpClient, private sharedService: SharedService) {}

  getFileTypes() {
    return this.http.get<BackendResponse<FileType>>(`${this.sharedService.baseUrl}pitches/self-publish/file-types`);
  }

  createFileType(name: string, tag: SelfPublishTag['id']) {
    return this.http.post<CreatedFileType>(`${this.sharedService.baseUrl}pitches/self-publish/file-types`, { name, tag });
  }

  patchFileType(id: string, payload: PatchFileType) {
    return this.http.patch<CreatedFileType>(`${this.sharedService.baseUrl}pitches/self-publish/file-types/${id}`, payload);
  }

  deleteFileType(id: string) {
    return this.http.delete<void>(`${this.sharedService.baseUrl}pitches/self-publish/file-types/${id}`);
  }

  getSelfPublishTags() {
    return this.http.get<BackendResponse<SelfPublishTag>>(`${this.sharedService.baseUrl}pitches/self-publish/tags`);
  }

  createSelfPublishTag(name: SelfPublishTag['name']) {
    return this.http.post<SelfPublishTag>(`${this.sharedService.baseUrl}pitches/self-publish/tags`, { name });
  }

  patchSelfPublishTag(id: SelfPublishTag['id'], name: SelfPublishTag['name']) {
    return this.http.patch<SelfPublishTag>(`${this.sharedService.baseUrl}pitches/self-publish/tags/${id}`, { name });
  }

  deleteSelfPublishTag(id: SelfPublishTag['id']) {
    return this.http.delete<void>(`${this.sharedService.baseUrl}pitches/self-publish/tags/${id}`);
  }
}
